/**
 * @generated SignedSource<<08ef9b57b32b51986941a39bf57ff6e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSuggestedTimesWarningRendererQuery$variables = {
  orgRelayId: string;
};
export type EventSuggestedTimesWarningRendererQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"EventSuggestedTimesWarning_org">;
  } | null;
};
export type EventSuggestedTimesWarningRendererQuery = {
  variables: EventSuggestedTimesWarningRendererQuery$variables;
  response: EventSuggestedTimesWarningRendererQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgRelayId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSuggestedTimesWarningRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventSuggestedTimesWarning_org"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventSuggestedTimesWarningRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                  }
                ],
                "concreteType": "WorkingGroupConnection",
                "kind": "LinkedField",
                "name": "workingGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkingGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Room",
                            "kind": "LinkedField",
                            "name": "rooms",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "roomId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "orgId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "estimatedCapacity",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workingGroups(first:1000000)"
              }
            ],
            "type": "Org",
            "abstractKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b2cd7a5ce73e48d569c9bb558291f852",
    "id": null,
    "metadata": {},
    "name": "EventSuggestedTimesWarningRendererQuery",
    "operationKind": "query",
    "text": "query EventSuggestedTimesWarningRendererQuery(\n  $orgRelayId: ID!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    ...EventSuggestedTimesWarning_org\n    id\n  }\n}\n\nfragment EventSuggestedTimesWarning_org on Org {\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        rooms {\n          id\n          roomId\n          orgId\n          name\n          estimatedCapacity\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c5198a13aa5c17cd3d0eb990db700d6";

export default node;
